import React, { useEffect, useState } from 'react'
import "../../scss/vendorMasterCreation.scss";
import SurveyorMasterCreation from '../surveyorMaster/surveyorMasterCreation';
import Select from 'react-select';
import { editModeOn, firstLetterCapital, getFromDecreaptLocalStorage, selectedproductName } from '../../utilFunctions';
import LoadingPage from '../../reusableComponents/loader/loadingPage';
import { toast } from 'react-toastify';
import { DragDropFile } from '../dragAndDropComponent';
import PdfViewer from '../../utilsComponent/PdfView';
import { useNavigate } from 'react-router-dom';
import { createVendorMaster, defaultVendorFileData, enterpriseCategoryOptions, getVendorData } from './helper';
import { fetchDistricts, fetchMandals, fetchStates, fetchVillages, handleFileChange } from '../apiHelper';
import DocumentPreviewModal from '../../utilsComponent/DocumentPreviewModal';
import AsteriskSymbol from '../../reusableComponents/AsteriskSymbol';
import { functionalities, PAGE_NAME_KEYS } from '../../consts';

const VendorMasterCreation = (props) => {
    const { roleDataCookie, productNames } = props
    const [surveyMasterShow, setSurveyMaster] = useState(false)
    const [statesList, setStatesList] = useState([])
    const [statesAllocationList, setStatesAllocationList] = useState([])
    const [districtList, setDistrictList] = useState([])
    const [districtAllocationList, setDistrictAllocationList] = useState([])
    const [mandalList, setMandalList] = useState([])
    const [mandalAllocationList, setMandalAllocationList] = useState([])
    const [villageList, setVillageList] = useState([])
    const [dragActive, setDragActive] = useState(false);
    const [isFileLoading, setIsFileLoading] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null);
    const [showFilePreview, setShowFilePreview] = useState(false);

    const defaultCreateVendorData = {
        "vendorType": "Survey",
        "vendorName": "",
        "email": "",
        "mobileNumber": "",
        "state": "",
        "district": "",
        "mandal": "",
        "village": "",
        "status": "",
        "address": "",
        "panNumber": "",
        "firmCategory": "",
        "enterpriseCategory": "",
        "memorandumOfArticles": defaultVendorFileData,
        "associationOfArticles": defaultVendorFileData,
        "certificateOfIncorporation": defaultVendorFileData,
        "udyamRegistration": defaultVendorFileData,
        "forLLPandPartnershipLLPDeed": defaultVendorFileData,
        "llpRegistration": defaultVendorFileData,
        "gst": defaultVendorFileData,
        "pan": defaultVendorFileData,
        "issla": defaultVendorFileData,
        "bankAccountNumber": "",
        "reenterBankAccountNumber": "",
        "bankName": "",
        "ifscCode": "",
        "branchName": "",
        "branchCode": "",
        "cancelledChequeOrBankPassbook": defaultVendorFileData,
        "product": "",
        "stateForAllocationDetails": "",
        "districtForAllocationDetails": "",
        "tehsilOrMandal": ""
    }
    const [createVendorData, setCreateVendorData] = useState(defaultCreateVendorData)
    const cmsStatusListCookies = getFromDecreaptLocalStorage("CMSstatusList")
    const navigate = useNavigate();
    const requiredUploadDocumentsList = [
        {name: "Memorandum of Articles", id: `Vendors/${createVendorData.vendorName}/memorandumOfArticles`, key: 'memorandumOfArticles', isRequired: true },
        {name: "Association of Articles", id: `vendors/${createVendorData.vendorName}/associationOfArticles`, key: 'associationOfArticles', isRequired: true },
        {name: "Certificate of Incorporation", id: `vendors/${createVendorData.vendorName}/certificateOfIncorporation`, key: 'certificateOfIncorporation', isRequired: true },
        {name: "Udyam Registration", id: `vendors/${createVendorData.vendorName}/udyamRegistration`, key: 'udyamRegistration', isRequired: false },
        {name: "For LLP and Partnership: LLP deed or Partnership deed", id: `vendors/${createVendorData.vendorName}/forLLPandPartnershipLLPDeed`, key: 'forLLPandPartnershipLLPDeed', isRequired: true },
        {name: "LLP Registration", id: `vendors-${createVendorData.vendorName}-llpRegistration`, key: 'llpRegistration', isRequired: false },
        {name: "GST", id: `vendors/${createVendorData.vendorName}/gst`, key: 'gst', isRequired: true },
        {name: "PAN", id: `vendors/${createVendorData.vendorName}/pan`, key: 'pan', isRequired: true },
        {name: "ISSLA", id: `vendors/${createVendorData.vendorName}/issla`, key: 'issla', isRequired: false },
    ];
    const keysForDocUrls = [
        'memorandumOfArticles',
        'associationOfArticles',
        'certificateOfIncorporation',
        'udyamRegistration',
        'forLLPandPartnershipLLPDeed',
        'llpRegistration',
        'gst',
        'pan',
        'issla',
        'cancelledChequeOrBankPassbook'
    ];
    const [docUrls, setDocUrls] = useState({});

    useEffect(() => {
        if(localStorage.getItem("id")){
            getVendorData(setCreateVendorData, getDistrictList, getDistrictAllocationList, getMandalList, getMandalAllocationList, getVillageList, keysForDocUrls, docUrls, setDocUrls)
        } else if(!editModeOn(functionalities.VENDOR_MASTER_TAB)) {
            navigate(`/dashboard/${PAGE_NAME_KEYS.FORBIDDEN}`)
        }
    },[])

    useEffect(() => {
        getStatesList()
        // getStatesAllocationList()
    }, [])

    const getStatesList =async() => {
        const fetchedStates = await fetchStates();
        setStatesList(fetchedStates);
        setStatesAllocationList(fetchedStates);
    }

    const getDistrictList = async(state) => {
        if (state) {
            const fetchedDistricts = await fetchDistricts(state);
            setDistrictList(fetchedDistricts)
        }
    }

    const getDistrictAllocationList = async(state) => {
        if (state) {
            const fetchedDistricts = await fetchDistricts(state);
            setDistrictAllocationList(fetchedDistricts)
        }
    }

    const getMandalList = async (district, state) => {
        if (district && state) {
            const fetchedMandals = await fetchMandals(district, state)
            setMandalList(fetchedMandals)
            
        }
    }
    const getMandalAllocationList = async(district, state) => {
        if (district && state) {
            const fetchedMandals = await fetchMandals(district, state)
            setMandalAllocationList(fetchedMandals)
        }
    }
    const getVillageList = async(mandal, district, state) => {
        if (mandal && district && state) {
            const fetchedVillages = await fetchVillages(mandal, district, state);
            setVillageList(fetchedVillages);
        }
    }
    const handleDragEnter = () => {
        setDragActive(true);
    };

    const handleDragLeave = () => {
        setDragActive(false);
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const handleDrop = (event) => {
        event.preventDefault();
        setDragActive(false);
        const fileData = event.dataTransfer.files[0];
        // file.push(fileData)
        // setFile([...file]);
    };

    const cancelCreateVandorMaster = () => {
        localStorage.removeItem("id")
        setCreateVendorData(defaultCreateVendorData)
        navigate(`/dashboard/${PAGE_NAME_KEYS.VENDOR_MASTER}`)
    }

    const handleFilePreview = (fileUrl, fileType, fileName ) => {
        if (fileUrl && fileType && fileName) {
            setShowFilePreview(true)
            setSelectedFile({
                url: fileUrl,
                type: fileType.toLowerCase(),
                name: fileName
            })
        }
    }



    return (
        <>
            {surveyMasterShow && (<SurveyorMasterCreation></SurveyorMasterCreation>)}
            {!surveyMasterShow && (<section className="p-4">
                <h1 className="headerclaim">
                    Vendor Master Creation
                </h1>
                <hr className="upper_hr" />
                <h2 className="heading_h2Masters">Vendor Master Creation - Survey</h2>
                <div className="inner-boxMasters">
                    <div className="container-fluid selectButtonsMasters">
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                               <label for="exampleInputPassword1">Vendor Type<AsteriskSymbol/></label>
                                <select name="selectMasters" className="selectMasters" value={createVendorData.vendorType} onChange={(e) => setCreateVendorData({ ...createVendorData, vendorType: e.target.value })}>
                                    <option value="Survey">Vendor Type - Survey</option>
                                    {/* <option value="qc">Vendor Type - QC</option> */}
                                </select>
                            </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                            <label for="exampleInputPassword1">Vendor Name<AsteriskSymbol/></label>
                               <input type="text" id="vendor_name" placeholder="Vendor Name" value={createVendorData.vendorName} className="selectMasters" onChange={(e) => setCreateVendorData({ ...createVendorData, vendorName: e.target.value })} />
                            </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                            <label for="exampleInputPassword1">Email<AsteriskSymbol/></label>
                               <input type="email" id="vendor_name" placeholder="Email" className="selectMasters" value={createVendorData.email} onChange={(e) => {setCreateVendorData({ ...createVendorData, email: e.target.value })}} />
                            </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                            <label for="exampleInputPassword1">Mobile Number<AsteriskSymbol/></label>
                                <input type="text" id="vendor_name" placeholder="Mobile Number" maxLength={10} className="selectMasters" value={createVendorData.mobileNumber} onChange={(e) => {
                                      const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                      e.target.value = numericValue;
                                    setCreateVendorData({ ...createVendorData, mobileNumber: e.target.value })}} />
                            </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <div className="form-group">
                                    <label for="exampleInputPassword1">State<AsteriskSymbol/></label>
                                    <Select id="exampleInputPassword1" options={statesList}
                                        classNamePrefix="bg-gray" placeholder="Select State"
                                        value={createVendorData.state ? { label: createVendorData.state, value: createVendorData.state } : { label: "Select State", value: "Select State" }}
                                        onChange={(data) => {
                                            getDistrictList(data.value)
                                            setCreateVendorData({
                                                ...createVendorData,
                                                state: data.value,
                                                district: "",
                                                mandal: "",
                                                village: ""
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                                <label for="exampleInputPassword2">District<AsteriskSymbol/></label>
                                <Select id="exampleInputPassword2" options={districtList}
                                    classNamePrefix="bg-gray" placeholder="Select District"
                                    isDisabled={!createVendorData.state}
                                    value={createVendorData.district ? { label: createVendorData.district, value: createVendorData.district } : { label: "Select District", value: "Select District" }}
                                    onChange={(data) => {
                                        getMandalList(data.value, createVendorData.state)
                                        setCreateVendorData({
                                            ...createVendorData,
                                            district: data.value,
                                            mandal: "",
                                            village: ""
                                        })
                                    }}
                                />
                            </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <div className="form-group">
                                    <label for="exampleInputPassword3">Mandal</label>
                                    <Select id="exampleInputPassword3" options={mandalList}
                                        classNamePrefix="bg-gray" placeholder="Select Mandal"
                                        isDisabled={!createVendorData.district}
                                        value={createVendorData.mandal ? { label: createVendorData.mandal, value: createVendorData.mandal } : ""}
                                        onChange={(data) => {
                                            getVillageList(data?.value || "", createVendorData.district,  createVendorData.state)
                                            setCreateVendorData({
                                                ...createVendorData,
                                                mandal: data?.value || "",
                                                village: "",
                                            })
                                        }}
                                        isClearable = {true}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <div className="form-group">
                                    <label for="exampleInputPassword1">Village</label>
                                    <Select id="exampleInputPassword1" options={villageList}
                                        classNamePrefix="bg-gray" placeholder="Select Village"
                                        isDisabled={!createVendorData.mandal}
                                        value={createVendorData.village ? { label: createVendorData.village, value: createVendorData.village } : ""}
                                        onChange={(data) => {
                                            setCreateVendorData({
                                                ...createVendorData,
                                                village: data?.value || "",
                                            })
                                        }}
                                        isClearable = {true}
                                    />
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                <div className="form-group">
                                    <label for="exampleInputPassword2">Status<AsteriskSymbol/></label>
                                    <Select id="exampleInputPassword2" options={cmsStatusListCookies.map(list => {
                                        return { label: firstLetterCapital(list.name), value: list.id }
                                    })}
                                        classNamePrefix="bg-gray" placeholder="Select District"
                                        value={createVendorData?.status ? { label: createVendorData.status } : { label: "Select Status", value: "Select Status" }}
                                        onChange={(data) => {
                                            setCreateVendorData({
                                                ...createVendorData,
                                                status: data.label,
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row mt-5">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 p-1">
                            <div className="form-group">
                            <label for="exampleInputPassword2">Address<AsteriskSymbol/></label>
                                <input type="text" id="address" placeholder="Address" value={createVendorData.address} className="selectMasters-full mx-2" onChange={(e) => {
                                    setCreateVendorData({
                                        ...createVendorData,
                                        address: e.target.value,
                                    })
                                }} />

                            </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                            <label for="exampleInputPassword2">Pan Number<AsteriskSymbol/></label>
                                <input type="text" id="pan" placeholder="Pan Number" value={createVendorData.panNumber} className="selectMasters" maxLength="10" onChange={(e) => {
                                    const alphabeticValue = e.target.value.replace(/[^A-Za-z0-9]/g, ''); //  accepting numbers and alphabets
                                    setCreateVendorData({
                                        ...createVendorData,
                                        panNumber: alphabeticValue.toLocaleUpperCase()
                                    })
                                }} />
                            </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                            <label for="exampleInputPassword2">Firm Category</label>
                                <input type="text" id="pan" placeholder="Firm Category" value={createVendorData.firmCategory} className="selectMasters" onChange={(e) => {
                                    setCreateVendorData({
                                        ...createVendorData,
                                        firmCategory: e.target.value,
                                    })
                                }} />

                            </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                            <label for="exampleInputPassword2">Enterprise Category</label>
                                <Select id="exampleInputPassword1" options={enterpriseCategoryOptions}
                                    classNamePrefix="bg-gray" placeholder="Enterprise Category"
                                    value={createVendorData.enterpriseCategory ? { label: createVendorData.enterpriseCategory, value: createVendorData.enterpriseCategory } : ""}
                                    onChange={(data) => {
                                        setCreateVendorData({
                                            ...createVendorData,
                                            enterpriseCategory: data?.value || "",
                                        })
                                    }}
                                    isClearable = {true}
                                />
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <div className="row">
                            {
                                requiredUploadDocumentsList.map(doc => (
                                    <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                        <div className="align1_dataMasters survey_box1Masters">
                                            {
                                                !createVendorData[doc.key]?.docName && createVendorData[doc.key]?.isFileLoading ? (
                                                    <LoadingPage/>
                                                ) : (
                                                    createVendorData[doc.key]?.docName ? (
                                                            <>
                                                            {editModeOn(functionalities.VENDOR_MASTER_TAB) && (
                                                                <div className='d-flex justify-content-end'>
                                                                    <i
                                                                        className="fa fa-trash trash-icon m-2 pointer"
                                                                        onClick={() => setCreateVendorData({ ...createVendorData, [doc.key]: defaultVendorFileData })}
                                                                        title="delete"
                                                                    ></i>
                                                                </div>
                                                            )}
                                                                <div onClick={()=>{handleFilePreview(docUrls[doc.key],createVendorData[doc.key]?.fileType, doc.name )}} className='file-view' title='Click to view'>
                                                                    {createVendorData[doc.key]?.fileType?.toLowerCase() === "pdf" ? (
                                                                        docUrls[doc.key] && (
                                                                            <div className="pdf-viewer">
                                                                                <PdfViewer docUrl={docUrls[doc.key]} hidePlugins/>
                                                                            </div>
                                                                        )
                                                                    ) : (
                                                                        <img src={(docUrls[doc.key])} title="Click to view"  className="center-imgMasters image-original-size" alt = {`${doc.name}`}/>
                                                                    )}
                                                                </div>
                                                            </>
                                                    ) : (
                                                        <>
                                                            <div
                                                                className="drop-zone"
                                                                onDragEnter={handleDragEnter}
                                                                onDragOver={handleDragOver}
                                                                onDragLeave={handleDragLeave}
                                                                onDrop={handleDrop}
                                                            >
                                                                <DragDropFile handleFileChange={(e) => handleFileChange(e, doc.id, doc.key, isFileLoading, setIsFileLoading, toast, roleDataCookie, createVendorData, setCreateVendorData, setDocUrls)} docId={doc.id} docKey={doc.key} disabled = {!editModeOn(functionalities.VENDOR_MASTER_TAB)}/>
                                                            </div>
                                                        </>
                                                    )
                                                )
                                            }
                                            <div className="img_descriptionMasters">
                                                {doc.name}
                                                {doc.isRequired && <span className='text-danger'>*</span>}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                    <div className="heading_detailsMasters">Bank Details</div>
                    <div className="container-fluid selectButtonsMasters">
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                                <label>Bank Account Number<AsteriskSymbol/></label>
                                <input type="text" id="vendor_name" placeholder="Bank Account Number" value={createVendorData.bankAccountNumber} className="selectMasters" onChange={(e) => setCreateVendorData({ ...createVendorData, bankAccountNumber: e.target.value })} />
                            </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                            <label>Re-enter Bank Account Number<AsteriskSymbol/></label>
                                <input type="text" id="vendor_name" placeholder="Re-enter Bank Account Number" className="selectMasters" value={createVendorData.reenterBankAccountNumber}  onChange={(e) => setCreateVendorData({ ...createVendorData, reenterBankAccountNumber: e.target.value })} />
                            </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                            <label>Bank Name<AsteriskSymbol/></label>
                                <input type="text" id="vendor_name" placeholder="Bank Name" className="selectMasters" value={createVendorData.bankName} onChange={(e) => setCreateVendorData({ ...createVendorData, bankName: e.target.value })} />
                            </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                            <label>IFSC Code<AsteriskSymbol/></label>
                                <input type="text" id="vendor_name" placeholder="IFSC Code" className="selectMasters" value={createVendorData.ifscCode} onChange={(e) => setCreateVendorData({ ...createVendorData, ifscCode: e.target.value })} />
                            </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                            <label>Branch Name<AsteriskSymbol/></label>
                                <input type="text" id="vendor_name" placeholder="Branch Name" className="selectMasters" value={createVendorData.branchName} onChange={(e) => setCreateVendorData({ ...createVendorData, branchName: e.target.value })} />
                            </div>
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12">
                            <div className="form-group">
                            <label>Branch Code<AsteriskSymbol/></label>
                            <input type="text" id="vendor_name" placeholder="Branch Code" className="selectMasters" value={createVendorData.branchCode} onChange={(e) => setCreateVendorData({ ...createVendorData, branchCode: e.target.value })} />
                            </div>
                               
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
                                <div className="align1_dataMasters survey_box1Masters">
                                {
                                        !createVendorData['cancelledChequeOrBankPassbook']?.docName && createVendorData['cancelledChequeOrBankPassbook']?.isFileLoading ? (
                                            <LoadingPage/>
                                        ) : (
                                            createVendorData['cancelledChequeOrBankPassbook']?.docName ? (
                                                <>
                                                {editModeOn(functionalities.VENDOR_MASTER_TAB) && (
                                                   <div className='d-flex justify-content-end'>
                                                        <i
                                                            className="fa fa-trash trash-icon m-2 pointer"
                                                            onClick={() => setCreateVendorData({ ...createVendorData, cancelledChequeOrBankPassbook: defaultVendorFileData })}
                                                            title="delete"
                                                        ></i>
                                                    </div>
                                                )}
                                                    <div onClick={()=>{handleFilePreview(docUrls['cancelledChequeOrBankPassbook'],createVendorData['cancelledChequeOrBankPassbook']?.fileType, 'Cancelled Cheque/Bank Passbook' )}} className="file-view" title="Click to view">
                                                        {createVendorData['cancelledChequeOrBankPassbook']?.fileType?.toLowerCase() === "pdf" ? (
                                                            docUrls['cancelledChequeOrBankPassbook'] && (
                                                                <div className="pdf-viewer">
                                                                    <PdfViewer docUrl={docUrls['cancelledChequeOrBankPassbook']} hidePlugins/>
                                                                </div>
                                                            )
                                                        ) : (
                                                            <img src={docUrls['cancelledChequeOrBankPassbook']} title="Click to view"  className="center-imgMasters image-original-size" alt="Cancelled Cheque/Bank Passbook"/>
                                                        )}
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div
                                                        className="drop-zone"
                                                        onDragEnter={handleDragEnter}
                                                        onDragOver={handleDragOver}
                                                        onDragLeave={handleDragLeave}
                                                        onDrop={handleDrop}
                                                    >
                                                         <DragDropFile handleFileChange={(e) => handleFileChange(e, `Vendors/${createVendorData.cancelledChequeOrBankPassbook}/memorandumOfArticles`, 'cancelledChequeOrBankPassbook', isFileLoading, setIsFileLoading, toast, roleDataCookie, createVendorData, setCreateVendorData, setDocUrls)} docId={`Vendors/${createVendorData.cancelledChequeOrBankPassbook}/memorandumOfArticles`} docKey={'cancelledChequeOrBankPassbook'} disabled = {!editModeOn(functionalities.VENDOR_MASTER_TAB)}/>
                                                    </div>
                                                </>
                                            )
                                        )
                                    }
                                    <div className="img_descriptionMasters">Cancelled Cheque/Bank Passbook<span className='text-danger'>*</span></div>
                                </div>
                        </div>
                    </div>
                </div>
                <div className = "heading_detailsMasters">Allocation Details</div>
                <div className = "container-fluid selectButtonsMasters">
                    <div className = "row document-alignMasters">
                        <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                        <div className="form-group">
                            <label for="exampleInputPassword1">Product Name</label>
                            <Select id="exampleInputPassword1" options={productNames}
                                onInputChange={(inputValue) => {
                                    // Replace non-alphanumeric characters
                                    const cleanedValue = inputValue.replace(/[^A-Za-z]/g, '');
                                    return cleanedValue; // Return cleaned value for the Select component
                                }}
                                classNamePrefix="bg-gray" placeholder="Select Kshema Product"
                                value={createVendorData.product ? selectedproductName(createVendorData.product, productNames) : ""}
                                onChange={(data) => {
                                    // getCropsList(data.label); 
                                    setCreateVendorData({ ...createVendorData, 'product': data?.value || "" })
                                }}
                                isClearable = {true}
                            />
                        </div>
                        </div>
                        <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                        <div className="form-group">
                                <label for="exampleInputPassword1">State<AsteriskSymbol/></label>
                                <Select id="exampleInputPassword1" options={statesAllocationList}
                                    classNamePrefix="bg-gray" placeholder="Select State"
                                    value={createVendorData.stateForAllocationDetails ? { label: createVendorData.stateForAllocationDetails, value: createVendorData.stateForAllocationDetails } : { label: "Select State", value: "Select State" }}
                                    onChange={(data) => {
                                        getDistrictAllocationList(data.value)
                                        setCreateVendorData({
                                            ...createVendorData,
                                            stateForAllocationDetails: data.value,
                                            districtForAllocationDetails: "",
                                            tehsilOrMandal: "",
                                        })
                                    }}
                                />
                            </div>
                        </div>
                        <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                        <div className="form-group">
                                <label for="exampleInputPassword2">District</label>
                                <Select id="exampleInputPassword2" options={districtAllocationList}
                                    classNamePrefix="bg-gray" placeholder="Select District"
                                    isDisabled={!createVendorData.stateForAllocationDetails}
                                    value={createVendorData.districtForAllocationDetails ? { label: createVendorData.districtForAllocationDetails, value: createVendorData.districtForAllocationDetails } : ""}
                                    onChange={(data) => {
                                        getMandalAllocationList(data?.value || "", createVendorData.stateForAllocationDetails)
                                        setCreateVendorData({
                                            ...createVendorData,
                                            districtForAllocationDetails: data?.value || "",
                                            tehsilOrMandal: ""
                                        })
                                    }}
                                    isClearable = {true}
                                />
                            </div> 
                        </div>
                        <div className = "col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                        <div className="form-group">
                                    <label for="exampleInputPassword3">Mandal</label>
                                    <Select id="exampleInputPassword3" options={mandalAllocationList}
                                        classNamePrefix="bg-gray" placeholder="Select Mandal"
                                        isDisabled={!createVendorData.districtForAllocationDetails}
                                        value={createVendorData.tehsilOrMandal ? { label: createVendorData.tehsilOrMandal, value: createVendorData.tehsilOrMandal } : ""}
                                        onChange={(data) => {
                                            setCreateVendorData({
                                                ...createVendorData,
                                                tehsilOrMandal: data?.value || "",
                                            })
                                        }}
                                    />
                                </div>
                        </div>
                    </div>
                    <div className='d-flex'>
                        <div className="backMasters" onClick={() => cancelCreateVandorMaster()}>Cancel</div>
                        {editModeOn(functionalities.VENDOR_MASTER_TAB) && (
                        <div className="submitMasters" onClick={() => createVendorMaster(createVendorData, toast, cancelCreateVandorMaster) }>Submit</div>
                        )}
                    </div>
                </div>
                </div>

            </section>)}

            {showFilePreview && selectedFile &&(
                <DocumentPreviewModal
                    fileType={selectedFile.type}
                    fileUrl={selectedFile.url}
                    heading={selectedFile.name}
                    onClose={()=>{
                        setShowFilePreview(false);
                        setSelectedFile(null)
                    }}
                    open={showFilePreview}
                />
            )}
        </>

    )
}

export default VendorMasterCreation
